import { UPDATE_RESUME_FORM_SUCCESS, UPDATE_RESUME_FORM_FAILURE, SET_SELECTED_TEMPLATE_SUCCESS, SET_SELECTED_TEMPLATE_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = {
  formData: {},
  selectedTemplate: null,
};

export default function resumeBuilder(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_RESUME_FORM_SUCCESS:
      return { ...state, formData: action.payload.data };
    case UPDATE_RESUME_FORM_FAILURE:
      return { ...state, formData: {} };
    case SET_SELECTED_TEMPLATE_SUCCESS:
      return { ...state, selectedTemplate: action.payload.data };
    case SET_SELECTED_TEMPLATE_FAILURE:
      return { ...state, selectedTemplate: null };
    default:
      return state;
  }
}
